export const PRODUCT_TYPES = {
  phone: "phone"
};
